var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlaws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16169",
    "data-name": "Group 16169",
    transform: "translate(-1536 -143.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3422",
    "data-name": "Rectangle 3422",
    width: 30,
    height: 30,
    transform: "translate(1536 143.507)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16170",
    "data-name": "Group 16170",
    transform: "translate(1539.562 39.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11423",
    "data-name": "Path 11423",
    d: "M1.933,120.132H7.347a1.8,1.8,0,0,0,1.146-.421,1.908,1.908,0,0,0,.6-1.505,2.542,2.542,0,0,1,.65-1.507,2.585,2.585,0,0,1,4.5,1.472,3.6,3.6,0,0,0,.1.783,1.711,1.711,0,0,0,1.643,1.179H21.4a1.711,1.711,0,0,0,.475-3.354,4.893,4.893,0,0,0-1.4-.067h-3.05a6,6,0,0,0-10.4-2.094,6.018,6.018,0,0,0-1.113,2.094H2.862a5.563,5.563,0,0,0-1.4.067,1.711,1.711,0,0,0,.474,3.354ZM1.6,117.581a1.2,1.2,0,0,1,.518-.059h4.1a.407.407,0,0,0,.391-.3,5.2,5.2,0,0,1,9.814-.9,5.025,5.025,0,0,1,.3.9.407.407,0,0,0,.391.3h4.1a1.3,1.3,0,0,1,.518.059.917.917,0,0,1,.547,1.041.9.9,0,0,1-.879.7h-5.02c-.474,0-.926.008-1.207-.463a1.274,1.274,0,0,1-.119-.626,3.394,3.394,0,0,0-6.777-.028,1.455,1.455,0,0,1-.151.7.9.9,0,0,1-.78.412H1.933a.9.9,0,0,1-.331-1.741Z",
    transform: "translate(-0.23 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11424",
    "data-name": "Path 11424",
    d: "M1.763,323.309H20.4a2.418,2.418,0,0,0,2.065-.588,1.744,1.744,0,0,0,.252-1.862,1.708,1.708,0,0,0-1.489-.967.475.475,0,0,0-.051,0H2.019c-.126,0-.253,0-.379,0a1.711,1.711,0,0,0,.123,3.419Zm-.6-2.434a1.162,1.162,0,0,1,.74-.176H21.172a.92.92,0,0,1,.891.76.9.9,0,0,1-.575.985,1.614,1.614,0,0,1-.573.056H1.707A.908.908,0,0,1,1.166,320.874Z",
    transform: "translate(0 -198.134)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaws);
export default __webpack_public_path__ + "static/media/flaws.efb8983af88b72d3707acec99220a125.svg";
export { ForwardRef as ReactComponent };